export function contractTypeList() {
  const query = `{
    contractTypeListByFilter(
      filter: { id: 0, filterByActive: false, active: false }
    ) {
      id
      name
      active
    }
  }
  `;
  return query;
}
export function contractSignatoryAvailableList(id) {
  const query = `{
    contractSignatoryAvailableList(contractTypeId: ${id}) {
      id
      name
      usuarioChatInterno
      ativo
      filterByStatus
      pedagogicAdm
      updaterId
      active
      usuarioChat
    }
  }
  `;
  return query;
}

export function contractTypeListByFilter(id) {
  const query = `{
    contractTypeListByFilter(
      filter: { id: ${id}, filterByActive: false, active: false }
    ) {
      id
      name
      active
      listOfSignatory {
        id
        signatory {
          id
          name
          usuarioChatInterno
          ativo
          filterByStatus
          pedagogicAdm
          updaterId
          active
          usuarioChat
        }
        position
      }
      listOfPages {
        id
        pageOrder
        name
        pageType
        fileName
        globalFileId
        contractTypeId
        fileUrl
      }
    }
  }
  `;
  return query;
}

export function contractTypeSaveMutation(
  values,
  uploadedFiles,
  filesAlreadyUploaded
) {
  const listOfSignatory = values.listOfSignatory.map((item) => ({
    id: 0,
    contractTypeId: values.id,
    signatory: {
      id: item.signatory.id,
      name: item.signatory.name,
      usuarioChatInterno: item.signatory.usuarioChatInterno,
      ativo: item.signatory.ativo,
      filterByStatus: item.signatory.filterByStatus,
      pedagogicAdm: item.signatory.pedagogicAdm,
      updaterId: item.signatory.updaterId,
      active: item.signatory.active,
      usuarioChat: item.signatory.usuarioChat,
    },
    position: item.position,
  }));

  const pages = uploadedFiles.map((item) => ({
    contractTypeId: values.id,
    id: 0,
    name: item.path,
    pageOrder: item.pageOrder,
    fileName: item.path,
    pageType: 'N',
    globalFileId: item.fileUrl.replace(/^.*\//g, ''),
  }));

  const listOfPagesUnordered = [...pages];
  let listOfPagesOrdered;
  if (filesAlreadyUploaded.length !== 0) {
    const oldPages = filesAlreadyUploaded.map((item) => {
      const { preview, type, uploadType, fileId, notExclude, ...itemRef } =
        item;
      return { ...itemRef, id: 0 };
    });
    listOfPagesOrdered = [...listOfPagesUnordered, ...oldPages];
  }

  const mutationQuery = `mutation {
    contractTypeSave(
      contractType: {
        id: ${values.id}
        name: "${values.name}"
        active: ${values.active}
        filterByStatus: false
        updaterId: 0
        listOfSignatory: ${JSON.stringify(listOfSignatory).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
        listOfPages: ${JSON.stringify(listOfPagesOrdered).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
      }
    ) {
      id
    }
  }
  `;
  return mutationQuery;
}

export function removeContractTypeMutation(id) {
  const query = `mutation {contractTypeRemove(contractTypeId: ${id})}`;
  return query;
}
